import axios from "axios";
import { API_CONFIG } from "../constants";
export interface getETHPriceOutput {
  price: number;
}
export async function getETHPrice(): Promise<getETHPriceOutput> {
  return (await axios.get(`${API_CONFIG.URL}/getEthPrice`)).data;
}
